import { observable } from './events';
import { getActiveConversation } from './app';

function log(level, message, data = {}) {
    observable.trigger(`log:${level}`, {
        timestamp: Date.now(),
        message,
        data,
    });
}

export function debug(message) {
    const data = {
        conversation: getActiveConversation(),
    };

    log('debug', message, data);
}
